<template>
  <div>
    <!-- A4 A5 STANDARD (LANDSCAPE, PORTRAIT) for CUSTOMER STATEMENT-->
    <div
      class="responsive-print"
      :id="field.temp_prop.paper_size==0?field.temp_prop.orientation==0?'customer-a4-standard-portrait-page':'customer-a4-standard-landscape-page':field.temp_prop.orientation==0?'customer-a5-standard-portrait-page':'customer-a5-standard-landscape-page'"
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.13);"
    >
      <div class="print-template customer-statement">
        <div
          class="invoice-header-block"
          :style="{'height':field.temp_prop.margin_top+'in','background':field.header_prop.is_header_bg_color==1?field.header_prop.header_bg_color.hex:'#fff'}"
        ></div>
        <!-- Body -->
        <div
          class="invoice-content-layout"
          :style="{'padding-right':field.temp_prop.margin_right +'in','padding-left':field.temp_prop.margin_right +'in', 'background':field.temp_prop.is_temp_bg_color==1?field.temp_prop.temp_bg_color.hex:'#fff' }"
        >
          <!-- Page Heading -->
          <div class="invoice-top-heading">
            <h5
              class="text-center"
              :style="{'font-size':field.header_prop.doc_title_size+'pt','color':field.header_prop.doc_title_color.hex}"
              style="margin-bottom:0px"
            >{{field.header_prop.doc_title}} John Smith</h5>
            <p
              style="margin-top:0px;margin-bottom:0px;"
              :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}"
              class="text-center"
            >{{getDateFormat(new Date(new Date().getFullYear(), new Date().getMonth(), 1))}} To {{getDateFormat(new Date(new Date().getFullYear(), new Date().getMonth()+1, 0))}}</p>
          </div>

          <!-- First Block -->
          <div class="invoice-first-block" style="display:flex;justify-content: space-between;">
            <!-- Organization Details -->
            <div>
              <div
                v-if="field.header_prop.show_org_name"
                :style="{'font-size':field.header_prop.org_name_size+'pt','color':field.header_prop.org_name_color.hex}"
                style="margin-bottom:1px;font-weight:500;"
              >Shanki Systems India Pvt Ltd</div>

              <div v-if="field.header_prop.show_org_addr" class="custom-invoice-address">
                <p :style="{'font-size':field.temp_prop.font_size+'pt'}">JKR Tower</p>
                <p :style="{'font-size':field.temp_prop.font_size+'pt'}">5/4 Moonlight Garden</p>
                <p :style="{'font-size':field.temp_prop.font_size+'pt'}">Coimbatore Tamil Nadu</p>
                <p :style="{'font-size':field.temp_prop.font_size+'pt'}">India 641048</p>
                <p :style="{'font-size':field.temp_prop.font_size+'pt'}">Mail: admin@shanki.com</p>
                <p :style="{'font-size':field.temp_prop.font_size+'pt'}">{{field.header_prop.phone}}: 76639488488</p>
                <p style="margin-bottom:0px;" :style="{'font-size':field.temp_prop.font_size+'pt'}">GSTIN: 12ASDF12345A1Z0</p>
              </div>
            </div>

            <!-- Organization Logo -->
            <div>
              <!-- Max width for Logo Block -->

              <!-- Logo Image -->
              <img
                v-if="field.header_prop.show_logo&&imageSrc==''"
                src="@/assets/logo/Shanki-logo.png"
                :style="{'width':field.header_prop.logo_width+'px'}"
                style="max-width:300px;max-height:183.05px;height:auto;"
              />
              <img
                v-if="field.header_prop.show_logo&&imageSrc!=''"
                :src="imageSrc"
                :style="{'width':field.header_prop.logo_width+'px'}"
                style="max-width:300px;max-height:183.05px;height:auto;"
              />
            </div>
          </div>
          <!-- End of First Block -->

          <!-- Second Block -->
          <div class="invoice-second-block" style="display:flow-root">
            <div style="display:flex;justify-content: space-between;">
              <!-- Bill Address -->
              <div v-if="field.header_prop.doc_bill_to.show">
                <div
                  :style="{'font-size':field.temp_prop.font_size+'pt','background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#535871','color':field.temp_prop.temp_label_color.hex}"
                  style="margin-bottom:1px;font-weight:700;padding: 2px 0px 2px 2px;"
                >To</div>
                <div
                  :style="{'font-size':field.header_prop.cus_name_size+'pt','color':field.header_prop.cus_name_color.hex}"
                  style="margin-bottom:1px;font-weight:500;color:#000;"
                >John Smith</div>

                <div class="custom-invoice-address">
                  <p :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">JKR Tower</p>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">5/4 Moonlight Garden</p>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">Coimbatore Tamil Nadu</p>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">India 641048</p>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">Ph: 76639488488</p>
                  <p :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">GSTIN: 12ASDF12345A1Z0</p>
                </div>
              </div>

              <!-- Invoice Details-->
              <div v-if="field.header_prop.show_acc_sum" style="width:40%">
                <div
                  :style="{'font-size':field.temp_prop.font_size+'pt','background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#535871','color':field.temp_prop.temp_label_color.hex}"
                  style="margin-bottom:1px;font-weight:700; padding: 2px 0px 2px 6px;word-break:break-word"
                >{{field.header_prop.total_sum_label}}</div>

                <table class="custom-invoice-details-table" :style="{'font-size':field.temp_prop.font_size+'pt'}">
                  <tbody style="word-break:break-word">
                    <tr v-if="field.header_prop.open_bal.show">
                      <td class="text-left" :style="{'color':field.temp_prop.temp_label_color.hex}" style="width:110px">{{field.header_prop.open_bal.label}}</td>
                      <td class="text-right" :style="{'color':field.temp_prop.temp_font_color.hex}">{{orgCurrencySymbol}} 0.00</td>
                    </tr>
                    <tr v-if="field.header_prop.inv_amt.show">
                      <td class="text-left" :style="{'color':field.temp_prop.temp_label_color.hex}" style="width:110px">{{field.header_prop.inv_amt.label}}</td>
                      <td class="text-right" :style="{'color':field.temp_prop.temp_font_color.hex}">{{orgCurrencySymbol}} 200.00</td>
                    </tr>
                    <tr v-if="field.header_prop.paid_amt.show">
                      <td class="text-left" :style="{'color':field.temp_prop.temp_label_color.hex}" style="width:110px">{{field.header_prop.paid_amt.label}}</td>
                      <td class="text-right" :style="{'color':field.temp_prop.temp_font_color.hex}">{{orgCurrencySymbol}} 100.00</td>
                    </tr>
                    <tr v-if="field.header_prop.bal_due.show">
                      <td
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.temp_label_color.hex}"
                        style="border-top: 1px dashed #ededed;font-weight:700;width:110px"
                      >{{field.header_prop.bal_due.label}}</td>
                      <td
                        class="text-right semi-bold"
                        style="border-top: 1px dashed #ededed;font-weight:700" :style="{'color':field.temp_prop.temp_font_color.hex}"
                      >{{orgCurrencySymbol}} 100.00</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--End of Second Block -->

          <!-- Fifth Block -->
          <div class="invoice-fifth-block" style="margin-top:15px;">
            <table class="custom-invoice-line-item-table">
              <thead
                class="semi-bold"
                :style="{'background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#535871','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}"
                style="word-break:break-word"
              >
                <th
                  v-if="field.item_prop.label.date.show"
                  style="width:15%;"
                  class="text-left semi-bold"
                >{{field.item_prop.label.date.label}}</th>
                <th
                  v-if="field.item_prop.label.transaction.show"
                  style="width:15%;"
                  class="semi-bold"
                >{{field.item_prop.label.transaction.label}}</th>
                <th
                  v-if="field.item_prop.label.detail.show"
                  style="width:20%;"
                  class="semi-bold"
                >{{field.item_prop.label.detail.label}}</th>
                <th
                  v-if="field.item_prop.label.amt.show"
                  style="width:10%;"
                  class="text-right semi-bold"
                >{{field.item_prop.label.amt.label}}</th>
                <th
                  v-if="field.item_prop.label.payments.show"
                  style="width:10%;"
                  class="text-right semi-bold"
                >{{field.item_prop.label.payments.label}}</th>
                 <th
                  v-if="field.item_prop.label.refund.show"
                  style="width:10%;"
                  class="text-right semi-bold"
                >{{field.item_prop.label.refund.label}}</th>
                <th
                  v-if="field.item_prop.label.bal.show"
                  style="width:15%;"
                  class="text-right semi-bold"
                >{{field.item_prop.label.bal.label}}</th>
              </thead>
              <tbody style="background:#fff;" :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">
                  <tr  :style="{'background':field.item_prop.layout.odd_row.hex}">
                  <td
                    v-if="field.item_prop.label.date.show"
                    class="text-left"
                    style="border-bottom:1px solid #ededed;width:15%;"
                  >{{getDateFormat(new Date())}}</td>
                  <td
                    v-if="field.item_prop.label.transaction.show"
                    style="border-bottom:1px solid #ededed;width:15%;"
                    
                    class="semi-bold"
                  >Opening Balance</td>
                  <td
                    v-if="field.item_prop.label.detail.show"
                    style="border-bottom:1px solid #ededed;width:20%;"
                  ></td>
                  <td
                    v-if="field.item_prop.label.amt.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%"
                  >0.00</td>
                  <td
                    v-if="field.item_prop.label.payments.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%;"
                  ></td>
                   <td
                    v-if="field.item_prop.label.refund.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%;"
                  ></td>
                  <td
                    v-if="field.item_prop.label.bal.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:15%;"
                  >0.00</td>
                </tr>
                <tr :style="{'background':field.item_prop.layout.even_row.hex}">
                  <td
                    v-if="field.item_prop.label.date.show"
                    class="text-left"
                    style="border-bottom:1px solid #ededed;width:15%;"
                  >{{getDateFormat(new Date())}}</td>
                  <td
                    v-if="field.item_prop.label.transaction.show"
                    style="border-bottom:1px solid #ededed;width:15%;"
                  >Invoice
                  </td>
                  <td
                    v-if="field.item_prop.label.detail.show"
                    style="border-bottom:1px solid #ededed;width:20%;"
                  >
                    <span
                      style="word-break: break-all"
                      class="d-block"
                      v-if="field.header_prop.doc_ref_no.show"
                    >{{field.header_prop.doc_ref_no.label}} 0012 </span>INV1001 - due on {{getDateFormat(new Date())}}
                   <span
                      style="word-break: break-all"
                      v-if="field.item_prop.label.pjt.show_pjt"
                      class="d-block"
                    >Print Ad </span>
                  </td>
                  <td
                    v-if="field.item_prop.label.amt.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%"
                  >100.00</td>
                  <td
                    v-if="field.item_prop.label.payments.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%;"
                  ></td>
                     <td
                    v-if="field.item_prop.label.refund.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%;"
                  ></td>
                  <td
                    v-if="field.item_prop.label.bal.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%;"
                  >100.00</td>
                </tr>
                <tr :style="{'background':field.item_prop.layout.odd_row.hex}">
                  <td
                    v-if="field.item_prop.label.date.show"
                    class="text-left"
                    style="border-bottom:1px solid #ededed;width:15%;"
                  >{{getDateFormat(new Date())}}</td>
                  <td
                    v-if="field.item_prop.label.transaction.show"
                    style="border-bottom:1px solid #ededed;width:15%;"
                  >Invoice</td>
                  <td
                    v-if="field.item_prop.label.detail.show"
                    style="border-bottom:1px solid #ededed;width:20%;"
                  >  <span
                      style="word-break: break-all"
                      class="d-block"
                      v-if="field.header_prop.doc_ref_no.show"
                    >{{field.header_prop.doc_ref_no.label}} 0012 </span>
                  CN1001 - due on {{getDateFormat(new Date())}}</td>
                  <td
                    v-if="field.item_prop.label.amt.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%"
                  ></td>
                  <td
                    v-if="field.item_prop.label.payments.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%;"
                  >100.00</td>
                     <td
                    v-if="field.item_prop.label.refund.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%;"
                  >200.00</td>
                  <td
                    v-if="field.item_prop.label.bal.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:15%;"
                  ></td>
                </tr>
                <tr :style="{'background':field.item_prop.layout.even_row.hex}">
                  <td
                    v-if="field.item_prop.label.date.show"
                    class="text-left"
                    style="border-bottom:1px solid #ededed;width:15%;"
                  >{{getDateFormat(new Date())}}</td>
                  <td
                    v-if="field.item_prop.label.transaction.show"
                    style="border-bottom:1px solid #ededed;width:15%;"
                  >Invoice</td>
                  <td
                    v-if="field.item_prop.label.detail.show"
                    style="border-bottom:1px solid #ededed;width:20%;"
                  >
                   <span
                      style="word-break: break-all"
                      class="d-block"
                      v-if="field.header_prop.doc_ref_no.show"
                    >{{field.header_prop.doc_ref_no.label}} 0012 </span>
                    INV1001 - due on {{getDateFormat(new Date())}}
                   <span
                      style="word-break: break-all"
                      class="d-block"
                      v-if="field.item_prop.label.pjt.show_pjt"
                    >Print Ad </span></td>
                  <td
                    v-if="field.item_prop.label.amt.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%"
                  >100.00</td>
                  
                  <td
                    v-if="field.item_prop.label.payments.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%;"
                  ></td>
                     <td
                    v-if="field.item_prop.label.refund.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:10%;"
                  ></td>
                  <td
                    v-if="field.item_prop.label.bal.show"
                    class="text-right"
                    style="border-bottom:1px solid #ededed;width:15%;"
                  >100.00</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End of Fifth Block -->
          <!-- Sixth Block -->
          <!-- Subtotal,total -->
          <!-- Tax,Discount -->
          <!-- Balance Due -->

          <div
            v-if="field.footer_prop.show_aging_detl"
            class="invoice-sixth-block balance-due-table"
            style="display: flow-root;"
          >
            <table class="table statement-due-table">
               <thead   :style="{'background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}">
                <tr>
                  <th colspan="5" class="text-center">Overdue</th>
                  <th rowspan="2" class="text-right">Balance Due</th>
                </tr>

                <tr>
                  <th class="text-right">Current</th>
                  <th class="text-right">1-15 days</th>
                  <th class="text-right">16-30 days</th>
                  <th class="text-right">31-45 days</th>
                  <th class="text-right">Above 45 days</th>
                </tr>
              </thead>
                <tbody :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">
                <tr :style="{'background':field.item_prop.layout.odd_row.hex}" >
                  <td class="text-right">100.00</td>
                  <td class="text-right">0.00</td>
                  <td class="text-right">0.00</td>
                  <td class="text-right">0.00</td>
                  <td class="text-right">0.00</td>
                  <td class="text-right fw-semi-bold">{{orgCurrencySymbol}} 100.00</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="invoice-sixth-block balance-due-block" style="display: flow-root;">
            <table class="custom-invoice-total-table float-right" style="width:50%;margin:4px;">
                 <tbody  :style="{'font-size':field.temp_prop.font_size+'pt','color':field.temp_prop.temp_font_color.hex}">
                <tr :style="{'background':field.temp_prop.is_temp_bg_color==1?field.temp_prop.temp_bg_color.hex:'#fff'}">

                  <td class="text-right semi-bold" style="font-size:8pt">Balance Due</td>
                  <td class="text-right semi-bold" style="font-size:8pt;color:#000">{{orgCurrencySymbol}} 100.00</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End of sixth block -->
        </div>
        <!-- Body End -->
        <div
          class="invoice-footer-block"
          :style="{'font-size':field.footer_prop.footer_font_size+'pt','color':field.footer_prop.footer_font_color.hex,'height':field.temp_prop.margin_bottom+'in','background':field.footer_prop.bg_color.show==1?field.footer_prop.bg_color.value.hex:'#fff'}"
        ></div>
      </div>
    </div>
    <!-- End of A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import { mapGetters } from "vuex";
export default {
  props: ["list"],
  data() {
    return {
      field: JSON.parse(JSON.stringify(this.list)),
      imageSrc: ""
    };
  },
  methods: {
    preview(eve) {
      this.field = JSON.parse(JSON.stringify(eve));
    }
  },
  mounted() {
    EventBus.$on("preview", this.preview); // to trigger the method from parentcomponent
  },
  created() {
    this.imageSrc =
      this.org_details.org_logo != null && this.org_details.org_logo != ""
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : "";
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapGetters(["org_details", "inv_settings_details","orgCurrencySymbol"])
  }
};
</script>

<style lang="scss" scoped>
// A4 STANDARD PORTRAIT CSS
// Bootstrap class
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
//Custom css
//A4 standard portrait
#a4-standard-portrait-page,
#customer-a4-standard-portrait-page {
  width: 21cm;
  min-height: fit-content !important;
}
//A4 standard landscape //A4 spreadsheet landscape
#a4-standard-landscape-page,
#customer-a4-standard-landscape-page {
  width: 29.7cm;
  min-height: fit-content !important;
}
//A5 standard portrait
#a5-standard-portrait-page,
#customer-a5-standard-portrait-page {
  width: 14.8cm;
  min-height: fit-content !important;
}
//A5 spreadsheet portrait
#a5-standard-landscape-page,
#customer-a5-standard-landscape-page {
  width: 21cm;
  min-height: fit-content !important;
}

#a4-standard-portrait-page .print-template,
#customer-a4-standard-portrait-page .print-template {
  zoom: 115%;
}
#a4-standard-landscape-page .invoice-content-layout,
#customer-a4-standard-landscape-page .invoice-content-layout {
  zoom: 130%;
}

#a5-standard-landscape-page .print-template,
#customer-a5-standard-landscape-page .print-template,
#a4-standard-landscape-page .print-template,
#customer-a4-standard-landscape-page .print-template {
  zoom: 80%;
}

.invoice-top-heading {
  margin-bottom: 30px;
}
.custom-invoice-address p {
  margin-bottom: 1px !important;
  font-size: 8pt;
}
.custom-invoice-address {
  margin-bottom: 5px;
}
table.custom-invoice-details-table > tbody > tr > td {
  padding: 1px !important;
}
.customer-statement table.custom-invoice-details-table > tbody > tr > td,
.statement-due-table > tbody > tr > td {
  padding: 6px !important;
}
.balance-due-table {
  margin-top: 20px;
}
table.custom-invoice-total-table.float-right > tbody > tr > td {
  padding: 2px !important;
}
table.shipping-details-table,
table.custom-invoice-line-item-table,
table.statement-due-table {
  width: 100% !important;
  border-collapse: collapse;
}
table.shipping-details-table td {
  border: 1px solid #ededed;
  padding: 3px !important;
}
table.custom-invoice-line-item-table thead > th {
  padding: 6px;
}
table.custom-invoice-line-item-table tbody > tr > td {
  padding: 8px !important;
}
.customer-statement table.custom-invoice-line-item-table tbody > tr > td,
.customer-statement table.custom-invoice-line-item-table thead > th {
  padding: 4px !important;
}

.signature-block {
  margin-top: 60px;
}
.terms-conditions {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.label-invoice-tag {
  width: 100px;
}
table.statement-due-table thead > tr > th,
table.statement-due-table tbody > tr > td {
  border: 1px solid #ededed;
  padding: 4px !important;
}
table.statement-due-table {
  border-top: 1px solid #ededed;
  padding: 4px !important;
}
@media (min-width: 10px) and (max-width: 768px) {
  #customer-a4-standard-portrait-page.responsive-print {
    zoom: 36%;
  }
  #customer-a4-standard-landscape-page.responsive-print {
    zoom: 26%;
  }
  #customer-a5-standard-portrait-page.responsive-print {
    zoom: 52%;
  }
  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 36%;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  #customer-a4-standard-portrait-page.responsive-print {
    zoom: 50%;
  }

  #customer-a4-standard-landscape-page.responsive-print {
    zoom: 35%;
  }
  #customer-a5-standard-portrait-page.responsive-print {
    zoom: 70%;
  }
  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 50%;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  #customer-a4-standard-portrait-page.responsive-print {
    zoom: 73%;
  }
  #customer-a4-standard-landscape-page.responsive-print {
    zoom: 55%;
  }
  #customer-a5-standard-portrait-page.responsive-print {
    zoom: 100%;
  }
  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 80%;
  }
}
@media (min-width: 1281px) and (max-width: 1366px) {
  #customer-a4-standard-portrait-page.responsive-print {
    zoom: 90%;
  }
  #customer-a4-standard-landscape-page.responsive-print {
    zoom: 64%;
  }
  #customer-a5-standard-portrait-page.responsive-print {
    zoom: 90%;
  }
  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 86%;
  }
}
@media (min-width: 1367px) and (max-width: 1440px) {
  #customer-a4-standard-portrait-page.responsive-print {
    zoom: 75%;
  }
  #customer-a4-standard-landscape-page.responsive-print {
    zoom: 70%;
  }

  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 97%;
  }
}
@media (min-width: 1605px) {
  #customer-a5-standard-landscape-page.responsive-print {
    zoom: 122%;
  }
}
</style>